import { Card, Col, Container, Row } from "reactstrap";
import Header from "../../components/globals/Header";
import FilterBasedSearch from "../../components/inputs/FilterBasedSearch";
import { dummyRecentSaved } from "../../dummyData";
import MostRecentPlaceCard from "../../components/cards/MostRecentPlaceCard";
import MostRecentSavedCard2 from "../../components/cards/MostRecentSavedCard2";
import { useSavedPlacesHooks } from "../../hooks/useSavedPlaces";
import { useTranslation } from "../../languages";

const Saved = () => {
  const {allSavedItems} = useSavedPlacesHooks();
  const mostRecentSaved = allSavedItems?.[0];
 

  const { t } = useTranslation();

  return (
    <div>
      <Container fluid>
        <Header title={t("saved")} />
        <div>
          <FilterBasedSearch />
          <Card className="border-none padding-33px  mt-2rem figma-card-radius ">
            <h4 className="color-primary-black-3 mb-1_5rem">
              {t("recentlySaved")}
            </h4>

            {mostRecentSaved&&<MostRecentPlaceCard details={mostRecentSaved} />}
            <div className="mt-4">
              <h4 className="color-primary-black-3 margin-bottom-19px">
                {t("visited")}
              </h4>
              <Row className="gx-4 gy-md-0 ">
                {allSavedItems
                  ?.map((item, at) => (
                    <Col className="my-2" key={at} md={6} lg={6} xxl={3}>
                      <MostRecentSavedCard2 details={item} />
                    </Col>
                  ))}
              </Row>
            </div>
          </Card>
        </div>
      </Container>
    </div>
  );
};

export default Saved;
